(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for daytask item
    module.controller('AgendaDaytaskController', [
        'TaskStateEnum',
        'SharedAgendaService',  
        AgendaDaytaskControllerFn
    ]);

    function AgendaDaytaskControllerFn(TaskStateEnum, SharedAgendaService) {
        var vm = this;

        // finished task state
        vm.finishedTaskState = null;

        activate();

        // activation work
        function activate() {
            vm.finishedTaskState = TaskStateEnum.Finished;
            vm.FollowUpByOperator = TaskStateEnum.FollowUpByOperator;
            vm.FollowUpByRingfoon = TaskStateEnum.FollowUpByRingfoon;

            var dayTasksAgendas = SharedAgendaService.getDayTasksAgendas();
            vm.showAgendaOwnerLabels = dayTasksAgendas.length > 1;
        } // activate

    }

})();